
if($('.js-data-table-my-playlists').length){

    function returnDataTableMyPlaylistsOptions(dataArray){
        return {
            data: dataArray,
            order: [],
            columns: [{
                    data: 'Title',
                    render: function (data, type, row, meta) {
                        if (type === 'display') {
                            return `<div class="df f-no-wrap fbc gap-4 fw">
                                        <span>${row.Title}</span>
                                        <div class="c-dark c-orange-hover cursor-pointer playlistCellLinkIcon js-event-stop-propagation js-copy-link-btn js-show-toast-btn" data-animation-time="5000" data-link="${row.Link}" title="Copy link">
                                            <svg class="icon w-24 h-24">
                                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/images/svg-sprite.svg#icon-chain-16"></use>
                                            </svg>
                                        </div>
                                    </div>`;
                        }
                        return data;
                    }
                },
                {
                    data: 'Videos',
                    render: function (data, type, row, meta) {
                        if (type === 'display') {
                            return `${row.Videos} videos`;
                        }
                        return data;
                    }
                },
                {
                    data: 'Date',
                    type: 'date',
                    render: function(data){
                        let formattedDate = moment(data).format('ll');
                        return formattedDate;
                    }
                },
                {
                    data: 'Class',
                    render: function (data, type, row, meta) {
                        if(type === 'display'){
                            return `<div class="playlistCellLabel">Class:</div><div>${row.Class}</div>`
                        }
                        return data;
                    }
                },
                {
                    data: 'Gender',
                    render: function (data, type, row, meta) {
                        if(type === 'display'){
                            return `<div class="playlistCellLabel">Gender:</div><div>${row.Gender}</div>`
                        }
                        return data;
                    }
                },
                {
                    data: 'Team',
                    render: function (data, type, row, meta) {
                        if(type === 'display'){
                            return `<div class="playlistCellLabel">Team:</div><div>${row.Team}</div>`
                        }
                        return data;
                    }
                },
                {data: 'Link'},
            ],
            columnDefs: [
                {
                    target: 6,
                    visible: false,
                    searchable: false
                },
            ],
            scrollX: true,
            fixedColumns: {
                leftColumns: 1
            },
            search: {
                caseInsensitive: true
            },
            // bDestroy - enable rerender table with new data array by event.
            bDestroy: true,
            pageLength: 15,
            layout: {
                top2Start: {
                    className: 'dt-search-cell',
                    features: function(){
                        const layout =
                        `<div class="form-item-wrap form-item-wrap--search-built-in js-form-item-wrap-search">
                            <input id='search-field' type="text" class='form-item form-item--search-built-in js-main-search js-search-custom' placeholder='Quick search' value=''>
                        <button class="btn-search-clear js-btn-search-clear" type='button' data-target='search-field'></button>
                        </div>`;

                        return layout;
                    }
                },
                topStart: {
                    info: {
                        text: 'PLAYLISTS: _TOTAL_',
                        empty: 'PLAYLISTS: _TOTAL_',
                        search: '',
                    }
                },
                topEnd: {
                    rowClass: 'dt-results-row',
                    className: 'dt-sort-by-cell-training',
                    features: function(){
                        const sortByData = ['Date'];
    
                        const layout =
                        `<div class="table-sort-mobile js-table-sort-mobile-container">
                            <button class="table-sort-mobile__button js-sort-by-button" data-drop="sort-by-dropdown">
                                <span class="df">
                                    Sort by<span class="hidden-flex gap-8 js-sort-by-container">:<span class="fw-400 js-sort-by-text"></span></span>
                                </span>
                            </button>
                            <div id="sort-by-dropdown" class="table-sort-mobile__dropdown dropdown under left js-sort-by-dropdown js-dropdown">
                            ${sortByData.map(item => `
                                    <button class="table-sort-mobile__option js-sort-by-mobile js-sort-by-mobile-${item.toLowerCase()}" type="button">
                                        <span class="js-sort-by-value">${item}</span>
                                        <span class="table-sort-mobile__order"></span>
                                    </button>
                                `).join("")
                            }
                            </div>
                        </div>`;
                        return layout;
                    }
                },
                bottomStart: null,
                bottomEnd: {
                    rowClass: 'dt-paging-row',
                    className: 'dt-paging-cell',
                    features: {
                        paging: {
                            type: "simple_numbers",
                            buttons: 6
                        }
                    }
                },
            },
            createdRow: function(row, data, dataIndex){
                $(row).each(function(index){
                    $(this).attr('data-href', data.Link).addClass('js-dt-row-clickable');
                });
            },
            initComplete: function () {
                // Add custom class to search input
                $('.dt-search').addClass('form-item-wrap form-item-wrap--search');

                setInfoResultsIntoMobileContainer(this.api().page.info().recordsDisplay);
            },
        }
    };

    let tableMyPlaylists = $('.js-data-table-my-playlists').DataTable(returnDataTableMyPlaylistsOptions(myPlaylistsDataArray));

    fireFunctionOnDataTablesNativeEvents(tableMyPlaylists);
    
    customSearch(tableMyPlaylists);
/* HELPER FUNCTIONS */

/* SORT BY MOBILE */
$(document).on('click', '.js-sort-by-mobile-date', function() {
    setSortByOrder(tableMyPlaylists, 2, $(this));
});

/* /HELPER FUNCTIONS */
}
